// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2ec5j","colMin":"styles_colMin__1mYkp","colCheckbox":"styles_colCheckbox__2x9hD"};